import { render, staticRenderFns } from "./MWhitelistContact.vue?vue&type=template&id=3388d1c8&scoped=true&lang=pug&"
import script from "./MWhitelistContact.vue?vue&type=script&lang=js&"
export * from "./MWhitelistContact.vue?vue&type=script&lang=js&"
import style0 from "./MWhitelistContact.vue?vue&type=style&index=0&id=3388d1c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3388d1c8",
  null
  
)

export default component.exports